/* eslint-disable no-console */
import { getPlatform } from '#src/lib/utils.mjs';

import { activateExperiments } from './activate-experiments';
import { setUser } from './vendors/optimizely';

export const setExperimentationUser = async (traits) => {
  console.log(`[setExperimentationUser] userId`, traits.id);
  try {
    const { email, id } = traits;
    if (!id) {
      return;
    }
    await setUser({
      app: 'wb-hub',
      isLoggedIn: !!email,
      platform: getPlatform(),
      userId: id.toString(),
      ...traits,
    });
    activateExperiments();
  } catch (e) {
    console.error(
      `[setExperimentationUser] Failed to set experimentation user`,
      e
    );
  }
};
